import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { showConfirm3DAction } from '@app/react/action';
import { getMediaMobile } from '@app/react/common/useMedia';

export interface IPartsViewUIReducer {
    previewMode: boolean; // 3d preview canvas element has nothing, for mobile 3d confirm view
}

const initState: IPartsViewUIReducer = {
    previewMode: !getMediaMobile().matches,
};

export const partsViewUIReducer = reducerWithInitialState(initState).case(
    showConfirm3DAction,
    (state, action) => {
        const { visible: previewMode } = action;

        return {
            ...state,
            previewMode,
        };
    },
);
